import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

$('.popup-login__close').click(() => {
    Popup.hide('login');
});

let isLoginInProgress = false;
$('.js-popup-login-form').submit(function (e) {
    e.preventDefault();
    const popup = $(this).parents('.popup');
    const button = popup.find('.popup-login-form__submit');
    const buttonText = button.attr('data-text');
    const buttonTextProgress = button.attr('data-text-progress');
    const errorText = popup.find('.popup-login-form__error');

    if (isLoginInProgress) {
        return;
    }

    errorText.hide();
    isLoginInProgress = true;
    button.text(buttonTextProgress);

    Api.post('/api/v2/account/login/', {
        login: $('.popup-login-form__input--login').val(),
        password: $('.popup-login-form__input--password').val()
    }).then((response) => {
        if (response.isError) {
            errorText.text(response.error).show();
            isLoginInProgress = false;
            button.text(buttonText);
        } else {
            if (window.location.pathname.indexOf('order')) {
                window.location = '/order/';
            } else {
                window.location = '/personal/profile';
            }
        }
    }).catch(() => {
        isLoginInProgress = false;
        errorText.text('Произошла ошибка авторизации, попробуйте позже').show();
    });
});
